<template>
    <tab-layout :buttons="more.buttons" :permissions="permissions" :parameters="parameters">
        <!-- TAB TITLE -->
        <template slot="title">
            {{ $l10n.__('Documents') }}
        </template>

        <template slot="content">
            <div v-if="isLoading" class="relative mt-3">
                <preloader :display="isLoading" />
            </div>

            <div v-if="!isLoading" class="flex-column ov-reset">
                <p class="tab-document__description typographies-paragraph-medium-regular">
                    {{ $l10n.__("Retrouvez l'ensemble des documents liés à votre opportunité") }}
                </p>
                <div v-if="mainDocument.length > 0">
                    <h3 class="tab-document__subtitle typographies-heading-h3">
                        {{ $l10n.__('Document principal de votre opportunité') }}
                    </h3>
                    <el-table
                        class="tab-document__table--main"
                        :data="mainDocument"
                        stripe
                        style="width: 100%"
                        fit
                    >
                        <!-- NUMBER + VIEW -->
                        <el-table-column
                            prop="ident"
                            :label="$t.__('common.labels.number')"
                            :width="296"
                        >
                            <template slot-scope="scope">
                                <div class="tab-document__table-item">
                                    <a :href="scope.row.link" class="link semibold">
                                        {{ scope.row.ident }}
                                    </a>
                                    <CompassButton
                                        :label="$t.__('overview.tabs.TabDocuments.preview')"
                                        type="secondary"
                                        size="small"
                                        class="tab-document__table-show-panel"
                                        left-icon="panel-right-expand"
                                        @click="displayPanel(scope.row)"
                                    />
                                </div>
                            </template>
                        </el-table-column>

                        <!-- OBJECT -->
                        <el-table-column
                            prop="object"
                            :label="$t.__('overview.tabs.TabDocuments.object')"
                        >
                            <template slot-scope="scope">
                                <span
                                    class="ellipsis"
                                    v-html="removeBreakline(scope.row.subject)"
                                ></span>
                            </template>
                        </el-table-column>

                        <!-- STATUS -->
                        <el-table-column
                            prop="step"
                            :label="$t.__('common.labels.status')"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <span class="chip" :class="statusChip(scope.row.step)"></span
                                    >{{ scope.row.stepLabel }}
                                </div>
                            </template>
                        </el-table-column>

                        <!-- DATE -->
                        <el-table-column prop="date" label="Date" width="180"> </el-table-column>

                        <!-- EXCL TAX -->
                        <el-table-column
                            prop="amountHT"
                            :label="$t.__('common.labels.amount_excluding_tax')"
                            width="180"
                        >
                        </el-table-column>

                        <!-- INCL TAX -->
                        <el-table-column
                            prop="amountTTC"
                            :label="$t.__('common.labels.amount_including_tax')"
                            width="220"
                        >
                        </el-table-column>
                    </el-table>
                </div>

                <h3 class="tab-document__subtitle typographies-heading-h3">
                    {{ $l10n.__('Autres documents de votre opportunité') }}
                </h3>
                <CompassTabs v-model="activeTab" class="tab-document__other">
                    <CompassTabPane
                        v-for="(tab, tabIndex) in filterAvailableDoctypes(tabs)"
                        :key="tabIndex"
                        :label="tab.label"
                        :name="tab.id"
                        :badge="tab.items.length"
                    >
                        <el-table
                            :data="tab.items"
                            stripe
                            style="width: 100%"
                            class="tab-document__table--others"
                        >
                            <!-- NUMBER -->
                            <el-table-column
                                prop="ident"
                                :label="$t.__('common.labels.number')"
                                :width="296"
                            >
                                <template slot-scope="scope">
                                    <div class="tab-document__table-item">
                                        <a :href="scope.row.link" class="link semibold">
                                            {{ scope.row.ident }}
                                        </a>
                                        <CompassButton
                                            :label="$t.__('overview.tabs.TabDocuments.preview')"
                                            type="secondary"
                                            size="small"
                                            class="tab-document__table-show-panel"
                                            left-icon="panel-right-expand"
                                            @click="displayPanel(scope.row)"
                                        />
                                    </div>
                                </template>
                            </el-table-column>

                            <!-- OBJECT -->
                            <el-table-column
                                prop="object"
                                :label="$t.__('overview.tabs.TabDocuments.object')"
                            >
                                <template slot-scope="scope">
                                    <span
                                        class="ellipsis"
                                        v-html="removeBreakline(scope.row.subject)"
                                    ></span>
                                </template>
                            </el-table-column>

                            <!-- STATUS -->
                            <el-table-column
                                prop="step"
                                :label="$t.__('common.labels.status')"
                                width="180"
                            >
                                <template slot-scope="scope">
                                    <div>
                                        <span
                                            class="chip"
                                            :class="statusChip(scope.row.step)"
                                        ></span
                                        >{{ scope.row.stepLabel }}
                                    </div>
                                </template>
                            </el-table-column>

                            <!-- DATE -->
                            <el-table-column prop="date" label="Date" width="180">
                            </el-table-column>

                            <!-- EXCL TAX -->
                            <el-table-column
                                prop="amountHT"
                                :label="$t.__('common.labels.amount_excluding_tax')"
                                width="180"
                            >
                            </el-table-column>

                            <!-- INCL TAX -->
                            <el-table-column
                                prop="amountTTC"
                                :label="$t.__('common.labels.amount_including_tax')"
                                width="180"
                            >
                            </el-table-column>

                            <!-- CTA -->
                            <el-table-column fixed="right" label="" width="40">
                                <template slot-scope="scope">
                                    <el-dropdown>
                                        <a href="javascript:;" class="btn-icon"
                                            ><i class="icon-burger"></i
                                        ></a>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item
                                                v-if="!scope.row.isMain"
                                                class="gray-100"
                                                @click.native="defineMainDocument(scope.row.linkid)"
                                            >
                                                {{
                                                    $l10n.__(
                                                        'Définir en tant que document principal',
                                                    )
                                                }}
                                            </el-dropdown-item>
                                            <el-dropdown-item
                                                class="gray-100"
                                                @click.native="unlinkDocument(scope.row.linkid)"
                                            >
                                                {{ $l10n.__('Délier le document') }}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                    </CompassTabPane>
                </CompassTabs>
            </div>
        </template>

        <template slot="placeholder">
            <div class="well">
                {{ placeholder }}
            </div>
        </template>
    </tab-layout>
</template>

<script>
import OverviewTabMixin from './OverviewTabMixin';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';
import Feature from 'Services/Feature';

export default {
    components: {
        Preloader,
        TabLayout,
    },
    mixins: [OverviewTabMixin],

    data() {
        return {
            activeTab: 'estimate',
            isLoading: true,
        };
    },
    computed: {
        documents() {
            return this.$store.getters.documents;
        },
        doctypes() {
            return this.$store.getters.doctypes;
        },
        opportunityThird() {
            return this.$store.getters.opportunityThird;
        },
        tabs() {
            return [
                {
                    id: 'estimate',
                    label: this.$l10n.__('Devis'),
                    items: this.estimates,
                },
                {
                    id: 'invoice',
                    label: this.$l10n.__('Factures'),
                    items: this.invoices,
                },
                {
                    id: 'order',
                    label: this.$l10n.__('Bon de commande'),
                    items: this.orders,
                },
                {
                    id: 'delivery',
                    label: this.$l10n.__('Bon de livraison'),
                    items: this.deliverys,
                },
                {
                    id: 'creditnote',
                    label: this.$l10n.__('Avoirs'),
                    items: this.creditnotes,
                },
                {
                    id: 'proforma',
                    label: this.$l10n.__('Proformas'),
                    items: this.proformas,
                },
            ];
        },
        estimates() {
            return this.documents.filter((document) => document.doctype === 'estimate');
        },
        invoices() {
            return this.documents.filter((document) => document.doctype === 'invoice');
        },
        orders() {
            return this.documents.filter((document) => document.doctype === 'order');
        },
        deliverys() {
            return this.documents.filter((document) => document.doctype === 'delivery');
        },
        creditnotes() {
            return this.documents.filter((document) => document.doctype === 'creditnote');
        },
        proformas() {
            return this.documents.filter((document) => document.doctype === 'proforma');
        },
        mainDocument() {
            return this.documents.length > 0
                ? this.documents.filter((document) => document.isMain)
                : [];
        },
        placeholder() {
            return this.$l10n.__('Aucun document lié trouvé');
        },
        parameters() {
            return [
                {
                    key: 'linkedid',
                    value: this.$store.getters.linkedid,
                },
                {
                    key: 'thirdid',
                    value: this.opportunityThird.find((param) => param.key === 'id').value,
                },
                {
                    key: 'relationtype',
                    value: this.opportunityThird.find((param) => param.key === 'relationType')
                        .value,
                },
            ];
        },
        permissions() {
            return this.$store.getters.permissions;
        },
    },

    created() {
        this.fetch();
    },

    methods: {
        callToast(text, type) {
            this.$pushToast({
                type: type,
                icon: true,
                text: text,
            });
        },
        displayPanel(document) {
            if (document?.publicLink?.length > 0) {
                const data = {
                    id: document.id,
                    linkId: document.linkid,
                    title: document.ident || '',
                    data: document.publicLink,
                    settings: {
                        isMainDocument: document.isMain,
                    },
                };
                this.$trigger('overview:openPanel', data);
            } else {
                this.$trigger('overview:closePanel');
                this.callToast(
                    this.$l10n.__(
                        'Une erreur est survenue lors du chargement du document. Veuillez réessayer.',
                    ),
                    'error',
                );
            }
        },
        fetch() {
            this.$store
                .dispatch('fetchDocuments', this.$store.getters.linkedid)
                .then(() => {
                    this.isLoading = false;
                })
                .catch(() => {
                    this.callToast(
                        this.$l10n.__(
                            'Une erreur est survenue lors du chargement des données. Veuillez réessayer.',
                            'error',
                        ),
                    );
                });
        },

        defineMainDocument(linkId) {
            this.isLoading = true;
            this.$store
                .dispatch('updateMainDocument', linkId)
                .then(() => {
                    this.callToast(
                        this.$l10n.__('Le document principal a bien été mis à jour.'),
                        'success',
                    );
                })
                .catch(() => {
                    this.callToast(
                        this.$l10n.__(
                            'Une erreur est survenue lors du chargement du document. Veuillez réessayer.',
                        ),
                        'error',
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        unlinkDocument(linkId) {
            window.Opportunity.unlink(linkId);
        },
        statusChip(statusChip) {
            return 'chip-' + statusChip;
        },
        filterAvailableDoctypes(list) {
            const tabsFiltered = [];
            _.each(list, (item) => {
                if (this.doctypes?.includes(item.id)) {
                    tabsFiltered.push(item);
                }
            });
            return tabsFiltered;
        },
        removeBreakline(html) {
            return html.replace(/<br\s*\/?>/gi, ' ');
        },
    },
};
</script>

<style lang="scss" scoped>
.tab-document {
    &__other::v-deep .compass-tabs__headers,
    &__title {
        margin-bottom: 16px;
    }

    &__subtitle {
        margin-top: 0;
        margin-bottom: 8px;
    }

    &__description {
        margin-top: 0;
        margin-bottom: 16px;
    }

    &__table {
        &--main {
            margin-bottom: 32px;
        }
        &--main,
        &--others {
            &.el-table::v-deep tr {
                td {
                    height: 40px;
                    padding: 0;
                    &:first-child .cell .compass-button {
                        white-space: nowrap;
                    }

                    .cell {
                        padding-left: var(--spacing-3);
                        padding-right: var(--spacing-3);
                    }
                }
            }
        }
        &--others {
            &.el-table::v-deep tr {
                td {
                    &:last-child .cell {
                        text-overflow: unset;
                    }
                }
            }
        }
        &-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover .tab-document__table-show-panel {
                visibility: visible;
                opacity: 1;
            }
        }
        &-show-panel {
            flex-shrink: 0;
            margin-left: 5px;
            visibility: hidden;
            opacity: 0;
        }
    }
}
</style>
